import {STLLoader} from 'three/examples/jsm/loaders/STLLoader.js';
import {useLoader, useFrame} from '@react-three/fiber';
import {Vector3,Quaternion} from 'three';
import {useRef} from 'react';

export const CustomElement = (props) => {

	const stl = useLoader(STLLoader, props.file);

	const groupRef = useRef();

	let positions = [];
	let rotations = [];

	if (props.dcoord){
		//if props.dcoord is set, we assume that we should be animating!

		let dquatp = new Quaternion(props.dcoord.dqp[0]/2, props.dcoord.dqp[1]/2, props.dcoord.dqp[2]/2, 1).normalize();

		for (let i = 0; i < props.visSettings.timeSteps; i++){
			let sc = i/(props.visSettings.timeSteps-1);
		
			let dpos = new Vector3();
			let drot = new Quaternion();
			
			//we're choosing to let node p determine the element's position and rotation
			//we can just use the increments, since the parent object ("group") is at origin
			dpos.lerpVectors(new Vector3(),props.dcoord.drp,sc);
			drot.slerpQuaternions(new Quaternion(),dquatp,sc);

			positions.push(dpos);
			rotations.push(drot);
		}
	}

	let time = 0;
	let getIndex = (delta) => {
		time += delta;
		return Math.round( (Math.sin(time * props.visSettings.rate) +1)/2*(props.visSettings.timeSteps-1) );
	};

	let iiPrev = 0;
	let iiNow = 0;

	useFrame( (state,delta)=>{ 
		//only do this if we're supposed to be animating (i.e. if dcoord is set)
		if (props.dcoord) {
			iiNow = getIndex(delta);
			if (iiNow !== iiPrev) {
				
				groupRef.current.position.copy(positions[iiNow]);
				groupRef.current.quaternion.copy(rotations[iiNow]);
				
				iiPrev = iiNow;
			}
		}
	});		

	return (
		<group ref={groupRef} key={props.id}>
		<mesh 
			geometry={stl} 
			scale={[props.scale,props.scale,props.scale]} 
			quaternion={new Quaternion().fromArray(props.rot)}>
		<meshPhongMaterial color={props.color} />
		</mesh>
		</group>
		);

}